'use strict';
module.exports = Odigeo.Model.extend({
    defaults: {
        seatCharacteristics: [],
        floor: 0,
        seatRow: 0,
        seatMapRow: 0,
        column: '',
        type: '',
        providerPrice: 0,
        totalPrice: 0,
    },
    idAttribute: 'numPassenger',
    segment: '',
    section: '',
});

